import React from 'react';
import * as Yup from 'yup';
import {
  Formik,
  Field,
} from 'formik';
import {
  useDispatch,
} from 'react-redux';
import {
  Link,
} from 'react-router-dom';

import {
  coreActions,
} from '@gymcloud/core';

import {
  getNamespaceSymbol,
} from 'web-utils';

import config from 'web-config';
import {
  NamespaceLogo,
  TextField,
  SetNamespace,
  PasswordField,
} from 'web-components';
import {
  Flex,
} from 'web-styled';
import * as S from '../styled';

const validationSchema = Yup.object().shape({
  username: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
  password: Yup.string()
    .required('Password is required'),
});

const namespace = getNamespaceSymbol();

const Login = () => {
  const dispatch = useDispatch();

  const onSubmit = (payload) => new Promise((resolve, reject) => {
    dispatch(
      coreActions.loginRequest({
        payload,
        callbacks: {
          onSuccess: resolve,
          onError: reject,
        },
      }),
    );
  });

  return (
    <S.PageWrap>
      <NamespaceLogo />
      <S.FormWrap>
        <S.FormTitle>
          Sign In to Your Account
        </S.FormTitle>
        <Formik
          onSubmit={onSubmit}
          initialValues={process.env.NODE_ENV === 'development'
            ? {
              username: 'prodtrainer@yopmail.com',
              password: 'gymcloud',
            } : {
              username: '',
              password: '',
            }}
          validateOnBlur={false}
          validationSchema={validationSchema}
        >
          {(formikProps) => (
            <S.Form column onSubmit={formikProps.handleSubmit}>
              <Flex column width="100%" spacing={15}>
                <Field
                  type="text"
                  name="username"
                  label="Email"
                  color="#121827"
                  autoFocus
                  placeholder="Enter email"
                  component={TextField}
                />
                <Field
                  name="password"
                  label="Password"
                  color="#121827"
                  autoComplete="off"
                  placeholder="Password"
                  component={PasswordField}
                />
                <S.SubmitButton
                  isLoading={formikProps.isSubmitting}
                  isDisabled={formikProps.isSubmitting}
                >
                  Sign in
                </S.SubmitButton>
                <Flex
                  column
                  spacing={10}
                  width="100%"
                  justify="center"
                  align="center"
                >
                  <Link to="/forgot-password">
                    Forgot password
                  </Link>
                  {['strongfirst'].indexOf(namespace) !== -1 && (
                    <span>
                      Don&apos;t have an account?
                      {' '}
                      {namespace === 'gymcloud' ? (
                        <a href="https://www.gymcloud.com/sign-up/">Sign up</a>
                      ) : (
                        <Link to="/signup">
                          Sign up
                        </Link>
                      )}
                    </span>
                  )}
                </Flex>
              </Flex>
            </S.Form>
          )}
        </Formik>
      </S.FormWrap>
      <S.TextCenter>
        {namespace === 'gymcloud' && (
          <a href={`${config.urls.landing}/contact`}>Contact us</a>
        )}
        {process.env.TARGET_ENV !== 'production' && (
          <SetNamespace />
        )}
      </S.TextCenter>
    </S.PageWrap>
  );
};

export default Login;
